import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './LoginPage.css';

export default function LoginPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // If already logged in, redirect away
  useEffect(() => {
    if (!loading && user) {
      navigate(user.profileComplete ? '/app/dashboard' : '/complete-profile', { replace: true });
    }
  }, [user, loading, navigate]);

  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/auth/google`;
  };

  if (loading) return null;

  return (
    <div className="login-page">
      {/* Left panel — branding */}
      <div className="login-left">
        <div className="login-left-content">
          <div className="login-logo">
            <div className="login-logo-icon">G</div>
            <span>GLA Exchange</span>
          </div>

          <h1 className="login-headline">
            Your campus.<br />Your marketplace.
          </h1>

          <p className="login-sub">
            Buy and sell notes, gear, clothing and more — 
            directly with fellow GLA students. No middlemen, no fees.
          </p>

          <div className="login-stats">
            {[
              { value: '500+', label: 'Students' },
              { value: '₹0',   label: 'Platform fee' },
              { value: '1min', label: 'To list an item' },
            ].map(s => (
              <div key={s.label} className="login-stat">
                <span className="login-stat-value">{s.value}</span>
                <span className="login-stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right panel — sign in card */}
      <div className="login-right">
        <div className="login-card">
          <div className="login-card-top">
            <h2>Sign in</h2>
            <p className="text-muted" style={{ fontSize: '0.9rem', marginTop: 6 }}>
              Use your GLA University Google account
            </p>
          </div>

          <button className="google-btn" onClick={handleGoogleLogin}>
            <GoogleIcon />
            Continue with Google
          </button>

          <p className="login-terms">
            By signing in you agree to our community guidelines.
            Only GLA University students can access this platform.
          </p>

          <div className="login-features">
            {[
              '🔒  Verified student community',
              '📞  Direct WhatsApp & call contact',
              '🏷️  Notes, gaming, clothing & more',
            ].map(f => (
              <div key={f} className="login-feature-item">{f}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );
}